import Vue from 'vue'
import VueHtmlToPaper from "vue-html-to-paper";

Vue.use(VueHtmlToPaper);